<template>
  <div class="loader" :class="size"></div>
</template>

<script>
/**
 * This is the component for loader
 * Props:
 *  - size: accepts sm,md,xs
 */
export default {
  name: 'Spinner',
  props: {
    size: {
      default: 'sm'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

$size: 30px;
$thickness: 3px;

.loader {
  border: $thickness solid $quinary;
  border-radius: 50%;
  border-top: $thickness solid $prime;
  width: $size;
  height: $size;
  animation: spin 1s linear infinite;
  &.xs {
    height: 0.55 * $size;
    width: 0.55 * $size;
    border-width: 1px;
  }
  &.md {
    height: 1.5 * $size;
    width: 1.5 * $size;
    border-width: 1.5 * $thickness;
  }
  &.lg {
    height: 2 * $size;
    width: 2 * $size;
    border-width: 1.5 * $thickness;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
